import { Breadcrumbs, Container, Link as MuiLink, Typography } from '@mui/material';
import React from 'react';
import { Datagrid, List, TextField, TextInput } from 'react-admin';
import { Link as RouterLink } from 'react-router';
import { YesNoField } from '../components/YesNoField.tsx';
import { RecordRowActions } from '../components/record/RecordRowActions.tsx';

const GroupList: React.FC = () => {
  const groupFilters = [<TextInput key="search" label="Search" source="q" alwaysOn />];

  return (
    <Container maxWidth="lg">
      <Breadcrumbs sx={{ mt: 2 }}>
        <MuiLink component={RouterLink} underline="hover" color="inherit" to="/">
          Dashboard
        </MuiLink>
        <Typography color="text.primary">Groups</Typography>
      </Breadcrumbs>
      {/* The API lists root groups only unless asked, which hid subgroups the
          pickers were already showing. */}
      <List filters={groupFilters} filter={{ includeSubgroups: true }}>
        <Datagrid rowClick="show">
          <TextField source="id" />
          <TextField source="name" />
          <TextField source="parent.name" label="Parent" emptyText="-" />
          <YesNoField source="isPond" label={'Is Pond?'} />
          <RecordRowActions />
        </Datagrid>
      </List>
    </Container>
  );
};

export default GroupList;
